import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-daohanglanxiala",
  "use": "icon-daohanglanxiala-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-daohanglanxiala\"><g transform=\"rotate(90 8 8)\" fill-rule=\"evenodd\"><circle cx=\"8\" cy=\"8\" r=\"8\" /><path d=\"M6.872 11.55c0 .388.518.636.814.34l3.335-3.336a.46.46 0 000-.667L7.686 4.552c-.289-.29-.814-.064-.814.334v6.665z\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/daohanglanxiala.svg
// module id = 454
// module chunks = 4